import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y,
} from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y]);

let swiperInstance = null;
let init = false;

function swiperMode() {
    let smallBreakpoint = window.matchMedia('(min-width: 0px) and (max-width: 960px)');
    let largeBreakpoint = window.matchMedia('(min-width: 961px)');

    if (smallBreakpoint.matches) {
        if (!init) {
            init = true;
            swiperInstance = new Swiper('.swiper-container.disabled-on-desktop', {
                slidesPerView: 1.3,
                spaceBetween: 8,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    400: {
                        slidesPerView: 1.2
                    },
                    577: {
                        slidesPerView: 2
                    },
                }
            });
        }
    } else if (largeBreakpoint.matches) {
        if (init && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
            init = false;
        }
    }
}

window.addEventListener('load', swiperMode);
window.addEventListener('resize', swiperMode);

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperNewsBlock');
    const nextButton = container.querySelector('.swiperNewsNext');
    const prevButton = container.querySelector('.swiperNewsPrev');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3.3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 3.3,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperGallerySlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperGalleryBlock');
    const nextButton = container.querySelector('.swiperGalleryNext');
    const prevButton = container.querySelector('.swiperGalleryPrev');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, A11y],
        slidesPerView: 2.5,
        spaceBetween: 16,        
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
            },
            992: {
                slidesPerView: 2.5,
            },
        },
    });
});

document.querySelectorAll('.filter-swiper').forEach((wrap) => {
    if (wrap.swiper) return;
    new Swiper(wrap, {
        slidesPerView: '4',
        freeMode: true,
        a11y: { 
            enabled: false,
        },
        breakpoints: {
            0:   { slidesPerView: 2.5 },
            576: { slidesPerView: 6.4 },
            768: { slidesPerView: 8.7 },
        },
    });
});


const partnerTickerControllers = new WeakMap();

function buildPartnerTickerController(ticker, section) {
    const wrapper = ticker.querySelector('.swiper-wrapper');
    if (!wrapper) {
        return null;
    }

    const originalSlides = Array.from(wrapper.children).filter((slide) => (
        slide.classList.contains('swiper-slide') && !slide.hasAttribute('data-ticker-clone')
    ));

    if (!originalSlides.length) {
        return null;
    }

    const controller = {
        wrapper,
        originalSlides,
        isPaused: false,
        cycleWidth: 0,
        offset: 0,
        lastTimestamp: null,
        rafId: null,
        speedPxPerSecond: 45,
        clones: [],
    };

    const removeClones = () => {
        controller.clones.forEach((clone) => clone.remove());
        controller.clones = [];
    };

    const getOuterWidth = (element) => {
        const styles = window.getComputedStyle(element);
        const marginLeft = Number.parseFloat(styles.marginLeft) || 0;
        const marginRight = Number.parseFloat(styles.marginRight) || 0;
        return element.getBoundingClientRect().width + marginLeft + marginRight;
    };

    controller.rebuildTrack = () => {
        removeClones();
        wrapper.style.transform = 'translate3d(0, 0, 0)';

        controller.cycleWidth = controller.originalSlides
            .reduce((sum, slide) => sum + getOuterWidth(slide), 0);

        if (controller.cycleWidth <= 0) {
            return;
        }

        const targetWidth = controller.cycleWidth + (ticker.clientWidth * 1.25);
        let safety = 0;

        while (wrapper.scrollWidth < targetWidth && safety < 10) {
            controller.originalSlides.forEach((slide) => {
                const clone = slide.cloneNode(true);
                clone.setAttribute('data-ticker-clone', 'true');
                wrapper.appendChild(clone);
                controller.clones.push(clone);
            });
            safety += 1;
        }

        controller.offset = controller.offset % controller.cycleWidth;
    };

    const step = (timestamp) => {
        if (controller.lastTimestamp === null) {
            controller.lastTimestamp = timestamp;
        }

        const deltaSeconds = (timestamp - controller.lastTimestamp) / 1000;
        controller.lastTimestamp = timestamp;

        if (!controller.isPaused && controller.cycleWidth > 0) {
            controller.offset += controller.speedPxPerSecond * deltaSeconds;
            if (controller.offset >= controller.cycleWidth) {
                controller.offset -= controller.cycleWidth;
            }
            wrapper.style.transform = `translate3d(${-controller.offset}px, 0, 0)`;
        }

        controller.rafId = window.requestAnimationFrame(step);
    };

    controller.pause = () => {
        controller.isPaused = true;
        if (section) {
            section.dataset.tickerPaused = 'true';
        }
    };

    controller.play = () => {
        controller.isPaused = false;
        if (section) {
            section.dataset.tickerPaused = 'false';
        }
    };

    controller.destroy = () => {
        if (controller.rafId !== null) {
            window.cancelAnimationFrame(controller.rafId);
            controller.rafId = null;
        }
        controller.lastTimestamp = null;
        controller.offset = 0;
        wrapper.style.transform = '';
        removeClones();
    };

    controller.rebuildTrack();
    controller.lastTimestamp = null;
    controller.rafId = window.requestAnimationFrame(step);

    return controller;
}

function partnerTickerMode() {
    const smallBreakpoint = window.matchMedia('(max-width: 991px)');
    const largeBreakpoint = window.matchMedia('(min-width: 992px)');

    document.querySelectorAll('.partnerTickerSwiper').forEach((ticker) => {
        const section = ticker.closest('.partner-logos');
        const toggleButton = section ? section.querySelector('[data-partner-ticker-toggle]') : null;
        const isTickerPaused = () => section && section.dataset.tickerPaused === 'true';

        const setToggleState = (isPaused, isDisabled = false) => {
            if (!toggleButton) {
                return;
            }
            const toggleIcon = toggleButton.querySelector('[data-partner-ticker-icon]');
            const iconName = isPaused ? 'play_arrow' : 'pause';

            toggleButton.disabled = isDisabled;
            toggleButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
            toggleButton.setAttribute('aria-label', isPaused ? 'Play ticker' : 'Pause ticker');

            if (toggleIcon) {
                toggleIcon.setAttribute('data-icon', iconName);
            }
        };

        if (toggleButton && toggleButton.dataset.bound !== 'true') {
            toggleButton.dataset.bound = 'true';

            toggleButton.addEventListener('click', () => {
                const controller = partnerTickerControllers.get(ticker);
                if (!controller) {
                    return;
                }

                if (isTickerPaused()) {
                    controller.play();
                    setToggleState(false);
                } else {
                    controller.pause();
                    setToggleState(true);
                }
            });
        }

        if (largeBreakpoint.matches) {
            let controller = partnerTickerControllers.get(ticker);
            if (!controller) {
                controller = buildPartnerTickerController(ticker, section);
                if (controller) {
                    partnerTickerControllers.set(ticker, controller);
                }
            } else {
                controller.rebuildTrack();
            }

            if (!controller) {
                return;
            }

            if (isTickerPaused()) {
                controller.pause();
                setToggleState(true);
            } else {
                controller.play();
                setToggleState(false);
            }
        } else if (smallBreakpoint.matches) {
            const controller = partnerTickerControllers.get(ticker);
            if (controller) {
                controller.destroy();
                partnerTickerControllers.delete(ticker);
            }
            setToggleState(isTickerPaused(), true);
        }
    });
}

window.addEventListener('load', partnerTickerMode);
window.addEventListener('resize', partnerTickerMode);
